// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

import PhoneNumberData from '../../types/PhoneNumberData';

/** Malaysia */
const MY: PhoneNumberData = [60, 'MY', 9, '00-000 0000', 10, '00-0000 0000'];

export default MY;
